import { createReducer, on, Action } from '@ngrx/store';
import { ShowLoader, HideLoader, ResetLoader } from '../actions';

const initialState: LoaderState = {
  isLoading: false,
  loadingCount: 0,
};

export interface LoaderState {
  isLoading: boolean;
  loadingCount: number;
}

export const LoaderStateReducer = createReducer(
  initialState,
  on(ShowLoader, (state) => {
    const newCount = state.loadingCount + 1;
    return {
      ...state,
      loadingCount: newCount,
      isLoading: newCount > 0,
    };
  }),
  on(HideLoader, (state) => {
    const newCount = Math.max(0, state.loadingCount - 1);
    return {
      ...state,
      loadingCount: newCount,
      isLoading: newCount > 0,
    };
  }),
  on(ResetLoader, () => initialState)
);

export function LoaderReducer(state: LoaderState = initialState, action: Action): LoaderState {
  return LoaderStateReducer(state, action);
}
